import React, { useState, useEffect } from "react";
import { api } from "../../services/api.js";
import { Button, Form, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import Menu from "../../comum/Menu/index.jsx";
import Footer from "../../comum/Footer/index.jsx";
import "./AssociarLoja.css"; // CSS adicional opcional
import Foto from "../Components/Foto";

export default function AssociarLoja() {
  const [matricula, setMatricula] = useState("");
  const [dados, setDados] = useState(null);
  const [foto, setFoto] = useState(
    "https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg"
  );
  const [lojas, setLojas] = useState([]);
  const [lojaSelecionada, setLojaSelecionada] = useState("");
  const [loading, setLoading] = useState(false);
  const [fotoSelecionada, setFotoSelecionada] = useState(null);

  const abrirFoto = () => {
    if (!foto) return;

    setFotoSelecionada({
      foto: foto,
      nome: dados?.nome,
      loja: dados?.secao,
    });
  };

  // Carrega lista de lojas
  useEffect(() => {
    api
      .get("/lojas/localizacao")
      .then((ret) => setLojas(ret.data))
      .catch((err) => console.error("Erro ao carregar lojas:", err));
  }, []);

  const buscarFuncionario = async () => {
    if (!matricula) {
      Swal.fire("Atenção", "Informe a matrícula do funcionário!", "warning");
      return;
    }

    setLoading(true);
    setDados(null);
    setFoto("https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg");

    try {
      const res = await api.get(`/usuario/dados/${matricula}`);
      if (!res.data || res.data.length === 0) {
        Swal.fire("Ops!", "Funcionário não encontrado!", "info");
        setLoading(false);
        return;
      }
      setDados(res.data[0]);
      buscarFoto(matricula);
    } catch (err) {
      Swal.fire("Erro", "Erro ao buscar dados do funcionário", "error");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const buscarFoto = async (matricula) => {
    try {
      const res = await api.get(`/usuario/foto/${matricula}`);
      if (res.data?.foto)
        setFoto("data:image/jpeg;base64," + res.data.foto);
    } catch {
      setFoto("https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg");
    }
  };

  const associarLoja = async () => {
    if (!dados) {
      Swal.fire("Atenção", "Busque um funcionário primeiro!", "warning");
      return;
    }
    if (!lojaSelecionada) {
      Swal.fire("Atenção", "Selecione uma loja!", "warning");
      return;
    }

    try {
      const res = await api.post("/usuarios/erps", {
        matricula,
        loja: lojaSelecionada,
      });

      const lojaNome =
        lojas.find((l) => l.cod_emp === lojaSelecionada)?.razao || "a filial";

      Swal.fire({
        icon: "success",
        title: "Sucesso!",
        text: `Usuário alterado com sucesso para a filial ${lojaSelecionada}. Aguarde aproximadamente 5 minutos para que a atualização seja refletida.`,
        confirmButtonColor: "#198754",
      });

      setLojaSelecionada("");
      setMatricula("");
      setDados(null);
      setFoto("https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg");
    } catch (err) {
      console.error(err);
      Swal.fire("Erro", "Não foi possível associar a loja!", "error");
    }
  };

  return (
    <>
      <Menu modulo="ARBOR" />
      <div className="container mt-4 mb-5">
        <h4 className="text-center mb-4">
          <i className="fa fa-link"></i> Associação de Funcionário à Loja
        </h4>

        <div className="card p-4 sombra border-0">
          {/* Campo de matrícula e botão de busca */}
          <div className="row mb-3 align-items-end">
            <div className="col-md-4 col-12 mb-2 mb-md-0">
              <label className="form-label">Matrícula</label>
              <input
                type="text"
                className="form-control"
                value={matricula}
                onChange={(e) => setMatricula(e.target.value)}
                placeholder="Digite a matrícula"
              />
            </div>
            <div className="col-md-2 col-12 text-center">
              <Button
                variant="primary"
                className="w-100 mt-2 mt-md-0"
                onClick={buscarFuncionario}
              >
                {loading ? <Spinner size="sm" /> : "Buscar"}
              </Button>
            </div>
          </div>

          {dados && (
            <>
              <div className="text-center mb-4">
                <img
                  src={foto}
                  alt="Foto do funcionário"
                  className="rounded-circle shadow"
                  style={{
                    width: 120,
                    height: 120,
                    objectFit: "cover",
                    cursor: "zoom-in",
                  }}
                  onClick={abrirFoto}
                />
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Nome</label>
                  <input
                    type="text"
                    className="form-control"
                    value={dados.nome}
                    disabled
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Seção</label>
                  <input
                    type="text"
                    className="form-control"
                    value={dados.secao}
                    disabled
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Função</label>
                  <input
                    type="text"
                    className="form-control"
                    value={dados.funcao}
                    disabled
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-8 col-12 mb-3 mb-md-0">
                  <label className="form-label">
                    <i className="fa fa-store"></i> Selecione a Loja
                  </label>
                  <Form.Select
                    value={lojaSelecionada}
                    onChange={(e) => setLojaSelecionada(e.target.value)}
                  >
                    <option value="">-- Escolha a Loja --</option>
                    {lojas.map((l, idx) => (
                      <option key={idx} value={l.cod_emp}>
                        {l.razao}
                      </option>
                    ))}
                  </Form.Select>
                </div>
                <div className="col-md-4 col-12 text-center">
                  <Button
                    variant="success"
                    className="w-100 mt-2 mt-md-0"
                    onClick={associarLoja}
                  >
                    <i className="fa fa-check"></i> Associar
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />

      <Foto
        show={!!fotoSelecionada}
        onClose={() => setFotoSelecionada(null)}
        foto={fotoSelecionada?.foto}
        nome={fotoSelecionada?.nome}
        info01={fotoSelecionada?.loja}
        info02=""
      />
    </>
  );
}
